import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { GlobalChangesService } from "@shared/services/global-changes/global-changes.service";

/**
 * Guarda la ruta `/maintenance-mode`: expulsa a quien llegue si el
 * mantenimiento ya terminó. Aquí sí se espera a Firestore, porque está fuera
 * del camino crítico y sacar a alguien por un flag obsoleto sería peor.
 */
export const MaintenanceModeGuard: CanActivateFn = async (): Promise<boolean> => {
  const router: Router = inject(Router);
  const globalChangesService: GlobalChangesService = inject(GlobalChangesService);

  const leaveIfMaintenanceEnded: () => boolean = (): boolean => {
    const isMaintenanceMode: boolean = Boolean(
      globalChangesService.globalFeatureData?.featureFlags?.["excuelawebMaintenanceMode"],
    );

    if (!isMaintenanceMode) {
      router.navigate(["/catalogue"]);
      return false;
    }

    return true;
  };

  if (globalChangesService.globalFeatureData) return leaveIfMaintenanceEnded();

  try {
    const data: Awaited<ReturnType<GlobalChangesService["waitForData"]>> =
      await globalChangesService.waitForData();

    if (!data) return true;

    return leaveIfMaintenanceEnded();
  } catch (_error) {
    return true;
  }
};
